/**
 * scrollTo
 *
 * @param anchor
 */
export function scrollTo(anchor, isSmooth = true) {
    if (anchor !== "") {
        if (isSmooth) {
            const element = document.getElementById(anchor);
            element.scrollIntoView({
                block: "start",
                behavior: "smooth",
            });
        }
        else {
            const element = document.getElementById(anchor);
            element.scrollIntoView({
                block: "start",
                behavior: "auto",
            });
        }
    }
    else {
        window.scrollTo(0, 0);
    }
}
export function iOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}
